<template>
  <section id="organizationSetting" class="content">
    <div class="orgSetting">
      <h2>Account Info</h2>

      <div class="ogrInfoCnt">

        <div :class="{ogrInfoItem: true, editing: editing.name}">
          <h4>Full Name</h4>
          <p v-if="form.name.label != ''">{{form.name.label}}</p>
          <p v-else>-</p>
          <div class="edit" v-on:click="editing.name = true">
            <img src="../assets/edit-icon.png"> Edit
          </div>
          <div class="fieldGroup">
            <form v-on:submit.prevent="saveChanges">
              <input type="text" class="field"
                placeholder="Input name"
                v-model="form.name.model">
              <button class="btn btnPrimary">Save</button>
              <button class="btn btnSecondary" type="button"
                v-on:click="cancelEditing('name')">Cancel</button>
            </form>
          </div>
        </div>

        <div :class="{ogrInfoItem: true, editing: editing.phone}">
          <h4>Phone</h4>
          <p v-if="form.phone.label != ''">{{form.phone.label}}</p>
          <p v-else>-</p>
          <div class="edit" v-on:click="editing.phone = true">
            <img src="../assets/edit-icon.png"> Edit
          </div>
          <div class="fieldGroup">
            <form v-on:submit.prevent="saveChanges">
              <input type="text" class="field"
                placeholder="Input phone"
                v-model="form.phone.model">
              <button class="btn btnPrimary">Save</button>
              <button class="btn btnSecondary" type="button"
                v-on:click="cancelEditing('phone')">Cancel</button>
            </form>
          </div>
        </div>

        <div :class="{ogrInfoItem: true, editing: editing.email}">
          <h4>Email</h4>
          <p v-if="form.email.label != ''">{{form.email.label}}</p>
          <p v-else>-</p>
          <div class="edit" v-on:click="editing.email = true">
            <img src="../assets/edit-icon.png"> Edit
          </div>
          <div class="fieldGroup">
            <form v-on:submit.prevent="saveChanges">
              <input type="text" class="field"
                placeholder="Input email"
                v-model="form.email.model">
              <button class="btn btnPrimary">Save</button>
              <button class="btn btnSecondary" type="button"
                v-on:click="cancelEditing('email')">Cancel</button>
            </form>
          </div>
        </div>

        <div :class="{ogrInfoItem: true, editing: editing.password}">
          <h4>Password</h4>
          <p>* * * * * *</p>
          <div class="edit" v-on:click="editing.password = true">
            <img src="../assets/edit-icon.png"> Edit
          </div>
          <div class="fieldGroup">
            <form v-on:submit.prevent="changePassword">
              <input type="password" :class="{field: true, hasError: form.oldPassword.error}"
                placeholder="Old password"
                v-on:input="fieldChanged('oldPassword')"
                v-model="form.oldPassword.model">
              <div class="fieldError" v-if="form.oldPassword.error">{{form.oldPassword.error}}</div>
              <input type="password" :class="{field: true, hasError: form.password.error}"
                placeholder="New password"
                v-on:input="fieldChanged('password')"
                v-model="form.password.model">
              <div class="fieldError" v-if="form.password.error">{{form.password.error}}</div>
              <input type="password" :class="{field: true, hasError: form.password2.error}"
                placeholder="Re-type password"
                v-on:input="fieldChanged('password2')"
                v-model="form.password2.model">
              <div class="fieldError" v-if="form.password2.error">{{form.password2.error}}</div>
              <button class="btn btnPrimary">Save</button>
              <button class="btn btnSecondary" type="button"
                v-on:click="cancelEditing('password')">Cancel</button>
            </form>
          </div>
        </div>

        <div :class="{ogrInfoItem: true}">
          <h4>Registered date</h4>
          <p>{{form.created.model}}</p>
        </div>

        <div :class="{ogrInfoItem: true}">
          <h4>Last Login</h4>
          <p v-if="form.lastLogin.model">{{form.lastLogin.model}}</p>
          <p v-else>Never</p>
        </div>

      </div>
    </div>

    <Snackbar v-if="showSnackbar" :content="showSnackbar"/>
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import Snackbar from '@/components/Snackbar.vue';

export default {
  name: 'home',
  components: {
    Snackbar,
  },
  data() {
    return {
      showSnackbar: null,
      editing: {
        name: false,
        phone: false,
        email: false,
        password: false,
      },
      form: {
        name: {
          model: '',
          label: '',
        },
        phone: {
          model: '',
          label: '',
        },
        email: {
          model: '',
          label: '',
        },
        oldPassword: {
          model: '',
          error: null,
        },
        password: {
          model: '',
          error: null,
        },
        password2: {
          model: '',
          error: null,
        },
        created: {
          model: 0,
        },
        lastLogin: {
          model: 0,
        },
      },
    };
  },
  methods: {
    ...mapActions([
      'chTitle', 'chCGB',
    ]),
    fieldChanged(field) {
      this.form[field].error = null;
    },
    cancelEditing(field) {
      this.form[field].model = this.form[field].label;
      this.editing[field] = false;
    },
    saveChanges() {
      this.editing.name = false;
      this.editing.phone = false;
      this.editing.email = false;

      this.form.name.label = this.form.name.model;
      this.form.phone.label = this.form.phone.model;
      this.form.email.label = this.form.email.model;

      this.$http.post(this.$config.uri('user/save'), {
        account: 1,
        name: this.form.name.model,
        email: this.form.email.model,
        phone: this.form.phone.model,
      }).then((response) => {
        if (response.data.status !== 200) {
          // Display error
          return;
        }

        this.showSnackbar = 'Changes changed.';
        setTimeout(() => {
          this.showSnackbar = null;
        }, 1500);
      });
    },
    changePassword() {
      if (this.form.oldPassword.model.trim() === '') {
        this.form.oldPassword.error = 'Please input old password.';
        return;
      }
      if (this.form.password.model.length < 8) {
        this.form.password.error = 'Password minimum 8 characters.';
        return;
      }
      if (this.form.password.model !== this.form.password2.model) {
        this.form.password2.error = 'Password did not match.';
        return;
      }

      this.editing.password = false;
      this.$http.post(this.$config.uri('user/password'), {
        oldPassword: this.form.oldPassword.model,
        newPassword: this.form.password.model,
      }).then((response) => {
        if (response.data.status === 307) {
          this.form[response.data.field].error = response.data.message;
        } if (response.data.status !== 200) {
          // Display error
          return;
        }

        this.showSnackbar = 'Password successfully changed.';
        setTimeout(() => {
          this.showSnackbar = null;
        }, 1500);
      });
    },
  },
  mounted() {
    this.chTitle('Account');
    this.chCGB(true);
    this.$http.get(this.$config.uri('user/detail'))
      .then((response) => {
        if (response.data.status !== 200) {
          // Dispay error
          return;
        }

        const { data: user } = response.data;
        this.form.name.model = user.name;
        this.form.name.label = user.name;

        this.form.phone.model = user.phone;
        this.form.phone.label = user.phone;

        this.form.email.model = user.email;
        this.form.email.label = user.email;

        this.form.created.model = user.created;
        this.form.lastLogin.model = user.lastLogin;
      });
  },
};
</script>

<style scoped lang="scss">
  .orgSetting{
    max-width: 700px;
    h2{
      font-size: 30px;
      // font-weight: normal;
    }
  }
  .ogrInfoItem{
    position: relative;
    margin: 0;
    padding: 20px 0;
    padding-left: 240px;
    .logo{
      width: 160px;
      height: 160px;
      border-radius: 50%;
      box-shadow: 2px 2px 6px rgba(0,0,0,.2);
      background-image: url(../assets/marriot-logo.jpg);
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
    }
    h4{
      position: absolute;
      left: 0;
      top: 20px;
      text-transform: uppercase;
      color: #888;
      margin: 0;
    }
    h4.h4logo{
      top: 90px;
    }
    p{
      margin: 0;
    }
    .fieldGroup{
      display: none;
      margin-bottom: 0;
      margin-left: -60px;
      .fieldError{
        margin-bottom: 10px;
      }
      .field{
        font-size: 16px;
        margin-bottom: 10px;
        padding: 8px 12px;
        max-width: 260px;
      }
      .field.hasError{
        border-color: red;
        margin-bottom: 0;
      }
      .btn{
        margin-right: 5px;
      }
    }
    .edit{
      color: #0747a6;
      font-weight: bold;
      position: absolute;
      left: 174px;
      top: 16px;
      padding: 4px 8px 5px;
      border-radius: 30px;
      cursor: pointer;
      img{
        height: 16px;
        margin: 2px 0 -2px;
      }
    }
    .edit.editLogo{
      top: 86px;
      left: 115px;
    }
    .edit:hover{
      background: #eee;
    }
  }
  .ogrInfoItem.editing{
    .edit, p, .aboutContent{
      display: none;
    }
    .fieldGroup{
      display: block;
    }
  }
</style>
